module.exports = __webpack_public_path__ + "img/772eba2.svg";